import React from "react";
import PropTypes from "prop-types";
import "./SearchField.styles.scss";

const SearchField = ({ searchFieldInput, searchHandler, clearHandler }) => {
  return (
    <div>
      <section className="search_field_component">
        <label>
          <i className="fa fa-search" aria-hidden="true"></i>
        </label>
        <input
          type="text"
          placeholder="search"
          name="search"
          id="search-input"
          className="shadow_effect"
          value={searchFieldInput}
          onChange={(e) => searchHandler(e)}
        />
        {searchFieldInput ? (
          <span className="clear_search" onClick={() => clearHandler()}>
            <i className="fa fa-times-circle" aria-hidden="true"></i>
          </span>
        ) : null}
      </section>
    </div>
  );
};

SearchField.propTypes = {
  searchFieldInput: PropTypes.string,
  searchHandler: PropTypes.func.isRequired,
  clearHandler: PropTypes.func.isRequired,
};
export default SearchField;



// WEBPACK FOOTER //
// ./src/components/common/searchField/SearchField.jsx